<template>
  <div>
    <div
      class="relative new-mode-header"
      :class="titleAlignmentClass"
      v-if="item.topLanguageMap && (item.topLanguageMap?.title || item.topLanguageMap?.name)"
    >
      <div>
        <div class="title-left">
          <!-- <img
            class="title-icon"
            v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
            :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
            alt
          /> -->
          <span class="title">{{ item.topLanguageMap?.title || item.topLanguageMap?.name || "" }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub" v-if="item.topLanguageMap?.subTitle">{{ item.topLanguageMap?.subTitle || "" }}</div>
      </div>
    </div>
    <div class="mode5-wrap" v-if="slides.length" :class="getIsMobile ? 'IsMobile mt10' : 'mt20'">
      <!-- <div class="title-wrap">
        <img
          class="title-icon"
          v-if="item.list[0]"
          :src="$utils.returnImgUrl(item.list[0]?.langInfoObj[lang]?.icon)"
          alt
        />
        <span class="title">{{ item.list[0]?.langInfoObj[lang]?.name }}</span>
      </div> -->
      <!-- 样式2标题 -->
      <template v-if="showType === 2">
        <div class="mode5-header">
          <div class="mode5-title" :class="styleMode">
            <span>{{ getFieldByLanguage("name") }}</span>
          </div>
          <div class="mode5-button" @click="btnCilck(list[0])" v-if="getFieldByLanguage('btuName')" :class="styleMode">
            <span>{{ getFieldByLanguage("btuName") }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <img
            v-if="getFieldByLanguage('icon')"
            class="mode5-bg"
            :class="styleMode"
            :src="$utils.returnImgUrl(getFieldByLanguage('icon'))"
            alt=""
          />
        </div>
      </template>

      <!-- 样式1|2 -->
      <template v-if="showType === 1 || showType === 2">
        <div v-if="getIsMobile" class="card-wrap">
          <el-carousel
            class="mode5-mobileBox"
            ref="mode5SlideCarousel"
            :loop="true"
            arrow="always"
            :autoplay="true"
            indicator-position="none"
            :interval="6000"
            :height="$px2rem(120)"
          >
            <el-carousel-item
              v-for="(v, i) in list"
              v-exposure="{ eid: v.eid, jump_value: item.list[0]?.jump }"
              :data-id="v.eid"
              :key="'h5_' + i"
            >
              <el-skeleton :loading="skeletonLoading" animated :throttle="0">
                <template slot="template">
                  <el-skeleton-item variant="image" style="width: 100%; height: 210px" />
                </template>
                <template>
                  <div class="mode5-item-box" @click="btnCilck(v)">
                    <div class="box">
                      <div class="top"><img :src="v.homeLogo" alt /></div>
                      <div class="center name">{{ v.homeName }}</div>
                      <div class="bottom">
                        <span v-if="getodds(v.markets, 1)">1</span
                        ><span v-if="getodds(v.markets, 1)">{{ getodds(v.markets, 1) }}</span>
                      </div>
                    </div>
                    <div
                      class="box"
                      :class="{
                        hideMiddle: !getodds(v.markets, 2),
                      }"
                    >
                      <div class="top">{{ v.matchTime | time2 }}</div>
                      <div class="center">{{ v.matchTime | time1 }}</div>
                      <div class="bottom" v-if="getodds(v.markets, 2)">
                        <span v-if="getodds(v.markets, 2)">X</span>
                        <span v-if="getodds(v.markets, 2)">{{ getodds(v.markets, 2) }}</span>
                      </div>
                    </div>
                    <div class="box">
                      <div class="top"><img :src="v.awayLogo" alt /></div>
                      <div class="center name">{{ v.awayName }}</div>
                      <div class="bottom">
                        <span v-if="getodds(v.markets, 3)">2</span>
                        <span v-if="getodds(v.markets, 3)">{{ getodds(v.markets, 3) }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-skeleton>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- type="card" -->
        <div class="card-wrap" v-if="!getIsMobile" :class="styleMode">
          <el-carousel
            :loop="true"
            :autoplay="false"
            arrow="never"
            indicator-position="none"
            :height="$px2rem(160)"
            id="mode5_pc_carousel"
            ref="mode5mode5SlideCarouselPc"
          >
            <el-carousel-item v-for="(it, i) in listPc" :key="'pc_' + i">
              <el-row :gutter="20" style="height: 100%">
                <el-col v-for="(v, j) in it" :key="j" :span="8" :class="{ isOnly: list.length === 1 }">
                  <el-skeleton :loading="skeletonLoading" animated :throttle="0">
                    <template slot="template">
                      <el-skeleton-item variant="image" style="width: 100%; height: 160px" />
                    </template>
                    <template>
                      <div
                        class="mode5-item-box"
                        v-exposure="{ eid: v.eid, jump_value: item.list[0]?.jump }"
                        :data-id="v.eid"
                        @click="btnCilck(v)"
                      >
                        <div class="box">
                          <div class="top"><img :src="v.homeLogo" alt /></div>
                          <div class="center name">{{ v.homeName }}</div>
                          <div class="bottom">
                            <span v-if="getodds(v.markets, 1)">1</span
                            ><span v-if="getodds(v.markets, 1)">{{ getodds(v.markets, 1) }}</span>
                          </div>
                        </div>
                        <div
                          class="box"
                          :class="{
                            hideMiddle: !getodds(v.markets, 2),
                          }"
                        >
                          <div class="top">{{ v.matchTime | time2 }}</div>
                          <div class="center">{{ v.matchTime | time1 }}</div>
                          <div class="bottom" v-if="getodds(v.markets, 2)">
                            <span v-if="getodds(v.markets, 2)">X</span>
                            <span v-if="getodds(v.markets, 2)">{{ getodds(v.markets, 2) }}</span>
                          </div>
                        </div>
                        <div class="box">
                          <div class="top"><img :src="v.awayLogo" alt /></div>
                          <div class="center name">{{ v.awayName }}</div>
                          <div class="bottom">
                            <span v-if="getodds(v.markets, 3)">2</span>
                            <span v-if="getodds(v.markets, 3)">{{ getodds(v.markets, 3) }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-skeleton>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>

          <i v-if="listPc && listPc.length > 1" @click="turnLeft" class="icon-arrow-common el-icon-arrow-left"></i>
          <i v-if="listPc && listPc.length > 1" @click="turnRight" class="icon-arrow-common el-icon-arrow-right"></i>
        </div>
      </template>

      <!-- 样式3 -->
      <template v-if="showType === 3">
        <div class="mode5-style3" @click="btnCilck(list[0])">
          <table class="mode5-style3-table">
            <thead>
              <tr>
                <td :colspan="2">
                  <div class="title-wrap text-left">
                    <img
                      v-if="getFieldByLanguage('icon')"
                      :src="$utils.returnImgUrl(getFieldByLanguage('icon'))"
                      class="thumb-img"
                      alt=""
                    />
                    <span>{{ getFieldByLanguage("name") }}</span>
                  </div>
                </td>
                <td style="width: 15%">1</td>
                <td style="width: 15%">2</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(v, i) in list"
                v-exposure="{ eid: v.eid, jump_value: item.list[0]?.jump }"
                :data-id="v.eid"
                :key="v.matchTime + i"
              >
                <td style="width: 12%" class="date-wrap-width">
                  <div class="date-wrap">
                    <img :src="star" class="thumb" alt="" />
                    <div class="date">{{ v.matchTime | time1 }}</div>
                    <div class="time">{{ v.matchTime | time2 }}</div>
                  </div>
                </td>
                <td class="text-left">
                  <div class="desc-wrap">
                    <div class="title">{{ v.homeName || "" }}</div>
                    <div class="desc">{{ v.awayName || "" }}</div>
                  </div>
                </td>
                <td>
                  <div class="res-wrap">
                    <div class="right">{{ getodds(v.markets, 1) }}</div>
                  </div>
                </td>
                <td>
                  <div class="res-wrap">
                    <div class="right">{{ getodds(v.markets, 3) }}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import mode5 from "@/lobby_common/mixins_views/homeModule/mode5.js";
export default {
  mixins: [mode5],
};
</script>
<style lang="scss" scoped>
.new-mode-header {
  padding: 0px 10px;
}
.IsMobile .mode5-item-box {
  height: 120px;
  border-radius: var(--radius-401);
}
.mode5-item-box {
  position: relative;
  width: 100%;
  height: 160px;
  text-align: center;
  overflow: hidden;
  border-radius: var(--radius-400);
  cursor: pointer;
  background: var(--background-1002);
  display: flex;
  justify-content: space-between;
  padding: 10px;
  box-sizing: border-box;
  color: var(--font-color-200);
}
</style>

<style lang="scss" scoped>
.mode5-style3 {
  background: var(--background-800);
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  @media (max-width: 768px) {
    font-size: 12px;
  }
  .date-wrap-width {
    @media (max-width: 768px) {
      width: 16% !important;
    }
  }
  &-table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    thead {
      padding: 0 10px;
      box-sizing: border-box;
      height: 45px;
      background: var(--background-700);
      border-radius: 10px 10px 0px 0px;
    }
    tbody {
      td {
        border-right: 1px solid var(--border-color-200);
        border-bottom: 1px solid var(--border-color-200);
        &:last-child {
          border-right: none;
        }
      }
      tr {
        padding: 5px 0;
        &:last-child {
          td {
            border-bottom: none;
          }
        }
      }
    }
  }
  .title-wrap {
    padding-left: 10px;
    display: flex;
    align-items: center;
    color: var(--font-color-100);
  }
  .desc-wrap {
    padding-left: 10px;
    line-height: 1.5;
  }
  .thumb-img {
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
  .date-wrap {
    padding: 10px 0;
    font-size: 14px;
    line-height: 18px;
    .thumb {
      width: 20px;
      height: 20px;
      margin-bottom: 4px;
    }
    @media (max-width: 768px) {
      font-size: 12px;
      line-height: 14px;
      .thumb {
        width: 16px;
        height: 16px;
        margin-bottom: 0;
      }
    }
  }
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.mode5-header {
  position: relative;
  height: 105px;
  @media (max-width: 768px) {
    height: 80px;
  }
}
.mode5-title {
  font-size: 20px;
  padding-bottom: 14px;
  color: var(--font-color-100);
  padding-top: 71px;
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 51px 10px 10px 10px;
  }

  &.style2left {
    text-align: right;
  }
}

.mode5-bg {
  position: absolute;
  right: 0;
  // top: -95px;
  top: 0;
  width: 220px;
  height: 200px;
  z-index: 1;

  @media (max-width: 768px) {
    width: 132px;
    height: 120px;
    // top: -40px;
    top: 0;
    right: 10px;
  }

  &.style2left {
    right: unset;
    left: 0;
    @media (max-width: 768px) {
      left: 10px;
    }
  }
}

.mode5-button {
  position: absolute;
  right: 0;
  // top: -10px;
  bottom: 10px;
  padding: 0 10px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--button-700);
  border-radius: 5px;
  opacity: 0.8;
  font-size: 12px;
  color: var(--font-color-200);
  z-index: 2;
  cursor: pointer;

  @media (max-width: 768px) {
    right: 10px;
  }

  &.style2left {
    right: unset;
    left: 0;
    @media (max-width: 768px) {
      left: 10px;
    }
  }

  ::v-deep .el-icon-arrow-right {
    position: unset;
    top: unset;
    width: unset;
    right: unset;
    margin-top: unset;
  }
}
.box {
  width: 32%;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-right: 5px;
  &.hideMiddle {
    height: 100px;
    @media (max-width: 768px) {
      height: 68px;
    }
  }
  .top {
    margin-top: 10px;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
    color: var(--font-color-200);
    img {
      width: 50px;
      height: 50px;
      display: block;
    }
  }
  .center {
    width: 100%;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.name {
      font-weight: bold;
      line-height: 22px;
    }
  }
  .bottom {
    background: var(--button-700);
    color: var(--font-color-200);
    border-radius: 5px;
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 8px;
    box-sizing: border-box;
  }
  &:last-child {
    margin-right: 0;
  }
}
.mode5-wrap {
  position: relative;
  // &.IsMobile {
  //   .title-wrap {
  //     .title-icon {
  //       margin-left: 10px;
  //     }
  //     .title {
  //       font-size: 15px;
  //     }
  //   }
  // }
  // .title-wrap {
  //   min-height: 40px;
  //   display: flex;
  //   align-items: center;
  //   box-sizing: border-box;
  //   margin-bottom: 5px;
  //   .title-icon {
  //     width: 20px;
  //     margin-right: 10px;
  //   }
  //   .title {
  //     font-size: 18px;
  //   }
  // }
  &.IsMobile.mt20 {
    margin-top: 0px;
  }
  &.IsMobile {
    .box {
      .top {
        height: 36px;
        img {
          height: 36px;
          width: 36px;
        }
      }
      .center {
        font-size: 14px;
      }
    }
    .card-wrap {
      padding: 0 10px;
    }
  }
  border-radius: 5px;
}
.card-wrap {
  position: relative;
  height: 100%;
}
::v-deep .el-carousel__indicators {
  left: 5%;
  bottom: 10px;
  transform: translateX(0);

  .el-carousel__indicator {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    padding: 0;
    margin: 0 5px;

    .el-carousel__button {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      border-radius: 6px;
      background-color: transparent;
      border-color: transparent;
      background: #999;
    }

    &.is-active button {
      background: #133ea1;
    }
  }

  &.el-carousel__indicators--outside {
    padding-top: 12px;
  }
}

#mode5_pc_carousel ::v-deep .el-carousel__indicators {
  position: relative !important;
  top: 0px !important;
  padding-top: 10px;
  left: 0%;
}
@media (min-width: 1310px) {
  #mode5_pc_carousel .el-carousel__item--card {
    margin-left: calc(-10% + 12px);
  }
}
.icon-arrow-common.el-icon-arrow-left {
  width: 30px;
  position: absolute;
  left: -35px;
  top: 50%;
  font-size: 30px;
  margin-top: -14px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
  background: transparent;
  color: var(--background-500);
  &.disabled {
    color: var(--background-500);
    background: transparent;
  }
}
.icon-arrow-common.el-icon-arrow-right {
  width: 30px;
  position: absolute;
  right: -35px;
  top: 50%;
  font-size: 30px;
  margin-top: -14px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
  background: transparent;
  color: var(--background-500);
  &.disabled {
    color: var(--background-500);
    background: transparent;
  }
}
.isOnly {
  margin: 0 33.33%;
}
</style>
